import {
  QuestionnaireModel,
  QuestionnaireLookups,
  CompleteRevisionModel,
  SkillMatchLookups,
  SimpleLookupModel,
  AddSkillMatchModel,
  FileDownloadModel,
} from "@/core/models";
import { HttpService, Utils, DownloadService } from "@/core/services";

export const QuestionnaireService = {
  getQuestionnaire() {
    return HttpService.getData<QuestionnaireModel>(`questionnaires/forUser`);
  },
  getQuestionnaireById(id: number) {
    return HttpService.getData<QuestionnaireModel>(`questionnaires/${id}`);
  },
  putQuestionnaire(model: QuestionnaireModel) {
    return HttpService.putModel("questionnaires", model);
  },
  getQuestionnaireLookups() {
    return HttpService.getData<QuestionnaireLookups>("questionnaires/lookups");
  },
  complete(model: CompleteRevisionModel) {
    return HttpService.putModel("questionnaires/complete", model);
  },
  checkOut(questionnaireId: number) {
    return HttpService.put(`questionnaires/${questionnaireId}/checkOut`);
  },
  undoCheckOut(questionnaireId: number) {
    return HttpService.put(`questionnaires/${questionnaireId}/checkOut/undo`);
  },
  undoCheckOutByUser() {
    return HttpService.put("questionnaires/checkOut/undo/byUser");
  },
  getSkillMatchLookups() {
    return HttpService.getData<SkillMatchLookups>("questionnaires/skill/match/lookups");
  },
  async addSkillMatch(model: AddSkillMatchModel) {
    const result = await HttpService.post("questionnaires/skill/match/add", model);

    return result.data as SimpleLookupModel;
  },
  downloadCriticalSkillsReport(id: number) {
    return HttpService.getData<FileDownloadModel>(`questionnaires/${id}/critical/skills/download`);
  },
  downloadCriticalSkillsReportForCompany(companyId: number) {
    return HttpService.getData<FileDownloadModel>(`questionnaires/company/${companyId}/critical/skills/download`);
  },
  downloadCriticalSkillsReportForUser() {
    return HttpService.getData<FileDownloadModel>("questionnaires/critical/skills/download");
  },
  generateCriticalSkillsFile(response: FileDownloadModel) {
    const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });

    DownloadService.download(blob, response.fileName);
  },
};
